import store from '@/store';
import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';

export interface HexabaseState {
  /** HexabaseのapplicationId */
  applicationId: string;
  /** HexabaseのworkspaceId */
  workspaceId: string;
  /** Hexabaseのdatastore群(アプリケーションが保持するテーブル) */
  datastoreIds: DataStore;
  /** ローディング表示 */
  isLoading: boolean;
}

interface DataStore {
  [datastoreName: string]: string;
}

/**
 * 認証関連の状態管理クラス
 * このクラスの状態はリロードしても状態が保持される
 */
@Module({
  name: 'hexabase',
  namespaced: true,
  dynamic: true,
  store,
  // ↓リロードしても状態を保持する場合に、この1行で追加制御が必要
  preserveState: sessionStorage.getItem('zion-ui') !== null
})
export class Hexabase extends VuexModule implements HexabaseState {
  applicationId = '';
  workspaceId = '';
  datastoreIds: DataStore = {};
  isLoading = false;

  /**
   * HexabaseのapplicationIdを設定する
   *
   * @param applicationId HexabaseのapplicationId
   */
  @Mutation
  setApplicationId(applicationId: string) {
    this.applicationId = applicationId;
  }

  /**
   * HexabaseのworkspaceIdを設定する
   *
   * @param workspaceId HexabaseのworkspaceId
   */
  @Mutation
  setWorkspaceId(workspaceId: string) {
    this.workspaceId = workspaceId;
  }

  /**
   * HexabaseのdatastoreIdsを設定する
   *
   * @param datastoreIds HexabaseのdatastoreIds
   */
  @Mutation
  setDatastoreIds(datastoreIds: DataStore) {
    this.datastoreIds = datastoreIds;
  }

  /**
   * ローディングを表示する
   *
   * @param isLoading ローディング表示可否
   */
  @Mutation
  setIsLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  /**
   * ローディング表示可否を取得する
   *
   * @returns ローディング表示可否
   */
  public get getIsLoading(): boolean {
    return this.isLoading;
  }

  /**
   * HexabaseStateをリセットする
   */
  @Mutation
  clearHexabaseState() {
    this.applicationId = '';
    this.workspaceId = '';
    this.datastoreIds = {};
    this.isLoading = false;
  }
}

export default getModule(Hexabase);
